export const getIPInformation = async () => {
  const response = await fetch("https://geolocation-db.com/json/");
  const data = await response.json();
  return data;
};

export const getQueryParams = (search: any, key: string) => {
  const params = new URLSearchParams(search);
  const ids = params.getAll(key);
  return ids;
};
